/**
 * Created by Carsten Bühler
 * User: c.buehler on 13.09.2017
 * Copyright: xdot GmbH 2015
 */

import { RemoteDataStore } from 'plugin/liferay-widgets-react-web';

export function defaultExtendedWebsocketModelUpdate(remote, wsUpdate, stationLabelName) {
    let newRemote;

    if (wsUpdate.labels) {
        if (wsUpdate.labels[stationLabelName] > 0) {
            const storeRemoteEntries = RemoteDataStore.remoteStatetoDataArray(remote);
            if (storeRemoteEntries && storeRemoteEntries.length > 0) {
                storeRemoteEntries.forEach(remoteEntry => {
                    if (remoteEntry.item) {
                        if (Array.isArray(remoteEntry.item)) {
                            let newList;
                            if (remoteEntry.query && remoteEntry.query.byId) {
                                if (remoteEntry.query.byId == wsUpdate.labels[stationLabelName]) {
                                    newList = RemoteDataStore.invalidateData(remoteEntry);
                                }
                            } else {
                                newList = RemoteDataStore.invalidateData(remoteEntry);
                            }
                            if (newList) {
                                if (!newRemote) {
                                    newRemote = (newRemote || (newRemote = { ...remote }));
                                }
                                newRemote[ remoteEntry.name ] = newList;
                            }
                        } else {
                            console.warn("Single Entries should not occure in store, only timeseries. Please check the implementation.");
                        }
                    }
                });
            }
        }
    }

    return newRemote || remote;
}

export function defaultBatchedExtendedWebsocketModelUpdate(remote, wsUpdate, stationLabelName) {
    let newRemote;

    if (Array.isArray(wsUpdate)){

        let processedListNames = [];

        wsUpdate.forEach( incomingEvent => {
            let wsEvent;
            if (incomingEvent instanceof String) {
                wsEvent = JSON.parse(incomingEvent);
            } else {
                wsEvent = incomingEvent;
            }
            if (wsEvent.labels) {
                if (wsEvent.labels[stationLabelName] > 0) {
                    const storeRemoteEntries = RemoteDataStore.remoteStatetoDataArray(remote);
                    if (storeRemoteEntries && storeRemoteEntries.length > 0) {
                        storeRemoteEntries.forEach(remoteEntry => {
                            if (remoteEntry.item) {
                                const wasProcessed = processedListNames.indexOf(remoteEntry.name)>=0;
                                if (!wasProcessed) {
                                    if (Array.isArray(remoteEntry.item)) {
                                        let newList;
                                        if (remoteEntry.query && remoteEntry.query.byId) {
                                            if (remoteEntry.query.byId == wsEvent.labels[stationLabelName]) {
                                                newList = RemoteDataStore.invalidateData(remoteEntry);
                                            }
                                        } else {
                                            newList = RemoteDataStore.invalidateData(remoteEntry);
                                        }
                                        if (newList) {
                                            if (!newRemote) {
                                                newRemote = (newRemote || (newRemote = { ...remote }));
                                            }
                                            newRemote[remoteEntry.name] = newList;
                                            processedListNames.push(remoteEntry.name);
                                        }

                                    } else {
                                        let newItem;
                                        if (remoteEntry.item.id == wsEvent.labels[stationLabelName]){
                                            newItem = RemoteDataStore.invalidateData(remoteEntry);
                                        }
                                        if (newItem) {
                                            if (!newRemote) {
                                                newRemote = (newRemote || (newRemote = { ...remote }));
                                            }
                                            newRemote[remoteEntry.name] = newItem;
                                            processedListNames.push(remoteEntry.name);
                                        }
                                    }
                                }
                            }
                        });
                    }
                }
            }

        });
    } else {
        return defaultExtendedWebsocketModelUpdate(remote, wsUpdate, stationLabelName);
    }

    return newRemote || remote;
}




// WEBPACK FOOTER //
// ./js/utils/timeseriesevent-util.js